// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"3472a1fc","977":"86fb7637"}[chunkId] + ".chunk.js";
};